import { h as __h } from "preact";
import { Component } from "preact";
import { apiRequest, ApiError } from "~/lib/api.js";
import html from "~/util/html.js";
import { PromiseSignal } from "~/util/promise.js";
import { search } from "~/util/router.js";
import Button from "~/component/Button.js";
import PublicLayout from "./PublicLayout.js";
import util from "~/style/util.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Email.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Email.module.css", import.meta.url);
const css = adopt(sheet);
class ConfirmError extends ApiError {
  static invalid = "This email verification link is either invalid or expired.";

  /** @override */
  get messages() {
    return {
      [ApiError.noField]: {
        unknown_error: "Couldn't verify email.",
        forbidden: ConfirmError.invalid,
        not_found: ConfirmError.invalid,
        invalid_token: ConfirmError.invalid
      }
    };
  }
}
export default class EmailConfirm extends Component {
  confirm = new PromiseSignal(async token => await apiRequest("POST", "/v2/email/confirm", {
    json: {
      token
    }
  }));
  render() {
    const error = this.confirm.error && ConfirmError.from(this.confirm.error);
    const token = search.value.token;
    const content = () => {
      if (!token) {
        return [" ", __h("p", {}, "Invalid email confirmation link."), " "];
      }
      if (this.confirm.success) {
        return [" ", __h("p", {}, "Email confirmed!"), " "];
      }
      return [__h("p", {}, "Click the button below to confirm your email address."), __h(Button, {
        level: "primary",
        loading: this.confirm.loading,
        onClick: () => this.confirm.invoke(token).catch(() => {})
      }, "Confirm email"), error ? __h("p", {
        "class": css.error
      }, error.message) : null];
    };
    return __h(PublicLayout, {
      title: "Confirm email address",
      "class": util.textCenter
    }, content());
  }
}